// =============================================================================
// SellerProducts constants — pulled out of SellerProducts.jsx so each
// extracted sub-component can import directly without going through the
// parent.
// =============================================================================

export const STATUS_TABS = [
  { id: "all",        label: "All" },
  { id: "active",     label: "Active" },
  { id: "paused",     label: "Paused" },
  { id: "low_stock",  label: "Low stock" },
  { id: "out",        label: "Out of stock" },
];

// Mirrors mobile/src/features/product/constants.ts.
export const PRESET_VARIANT_TYPES = [
  { label: "Size",     icon: "👕", presets: ["XS", "S", "M", "L", "XL", "XXL"] },
  { label: "Color",    icon: "🎨", presets: ["Black", "White", "Red", "Blue", "Green", "Yellow", "Pink", "Grey"] },
  { label: "Storage",  icon: "💾", presets: ["64GB", "128GB", "256GB", "512GB", "1TB"] },
  { label: "Material", icon: "🧵", presets: ["Cotton", "Polyester", "Leather", "Wool", "Linen"] },
  { label: "Custom",   icon: "✏️", presets: [] },
];

export const DELIVERY_METHODS = [
  { id: "pickup",  label: "Customer pickup", icon: "map-pin", desc: "Buyer collects from your store" },
  { id: "self",    label: "Self-delivery",   icon: "truck",   desc: "You deliver the order yourself" },
  { id: "courier", label: "Courier",         icon: "package", desc: "Third-party courier delivery" },
];

export const MAX_PHOTOS = 5;
